const aroOptions = [
  {
      key: 0,
      value: '0',
      label: '0',
  },
  {
      key: 1,
      value: '1-50',
      label: '1-50',
  },
  {
      key: 2,
      value: '51-100',
      label: '51-100',
  },
  {
      key: 3,
      value: '101-250',
      label: '101-250',
  },
  {
      key: 4,
      value: 'More than 250',
      label: 'More than 250',
  },
]

export default aroOptions